"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import PopularCategoryCard from "../cards/popularCategoryCard/PopularCategoryCard";

interface PopularCategoriesProps {
  categories?: SectionItem[];
}

const PopularCategories = ({ categories }: PopularCategoriesProps) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
      {categories.map((category, index) => (
        <PopularCategoryCard
          key={category.id ?? `category-${index}`}
          category={category}
        />
      ))}
    </div>
  );
};

export default PopularCategories;
